module.exports = __webpack_public_path__ + "img/bbht1.1aabff8c.jpg";